export default __webpack_public_path__ + "static/media/some-album.fb4b20f5.png";